<form [formGroup]="form">
  <h2>{{ title }}</h2>

  @for (paragraph of content; track paragraph) {
    <p>{{ paragraph }}</p>
  }

  <nom-select-input
    [control]="select"
    >
    @for (option of options; track option) {
      <option
        [value]="option.value"
      >{{option.label}}</option>
    }
  </nom-select-input>

  <div class="button-group">
    <button
      class="btn btn-secondary btn-wide"
      type="button"
      (click)="cancel()"
      >
      {{ cancelText }}
    </button>
    <button
      class="btn btn-primary btn-wide"
      type="button"
      (click)="confirm()"
      >
      {{ confirmText }}
    </button>
  </div>
</form>
